export default {
    GET_PLAN_PRIORITIZATION_PRODUCTION_SITES_REQUEST: state => {
        state.productionSitesLoading = true
    },
    GET_PLAN_PRIORITIZATION_PRODUCTION_SITES_SUCCESS: (state, data) => {
        state.productionSites = data
        state.productionSitesLoading = false
    },
    GET_PLAN_PRIORITIZATION_PRODUCTION_SITES_FAILURE: state => {
        state.productionSitesLoading = false
    },
}
